import React from 'react';
import ErrorBoundaryForComponents from '../../../../util/ErrorBoundaryForComponents';
import General1 from './General1';

export default function PatientSummary() {
  return (
    <div>
      <ErrorBoundaryForComponents>
        <General1 />
      </ErrorBoundaryForComponents>
    </div>
  );
}
